export default __webpack_public_path__ + "static/media/DSC_0550.3cb33986.jpg";